@if (contentfulSectionsContent && !FAQLandingContent) {
  @for (contentfulSectionContent of contentfulSectionsContent; track trackBySlug) {
    <section [ngClass]="['page-body', slugClass]">
      @if (contentfulSectionContent.contentType === 'articleOverview') {
        <div class="d-contents title-and-image-article-section">
          @if (hasCategory) {
            <div>
              <a class="contentful-page__category" [href]="articleCategory?.slug">
                {{ articleCategory?.title }}
              </a>
            </div>
          } @else {
            <app-contentful-article-breadcrumbs [contentfulSectionContent]="contentfulSectionContent" />
          }
          <app-contentful-title [contentfulSectionContent]="contentfulSectionContent" />
          @if (desktopImage) {
            <div class="desktop-image" [ngClass]="{ 'mobile-hide': mobileImage }">
              <app-contentful-cloudinary-image [cloudinaryImage]="desktopImage" [mediaType]="'image'" />
            </div>
          }
          @if (mobileImage) {
            <div class="mobile-image">
              <app-contentful-cloudinary-image [cloudinaryImage]="mobileImage" [mediaType]="'image'" />
            </div>
          }
          <app-contentful-description [contentfulSectionContent]="contentfulSectionContent" />
        </div>
        <div class="container-fluid">
          <div class="row justify-content-center">
            <app-contentful-mini-navigation [contentfulSectionContent]="contentfulSectionContent" />
            <app-contentful-share-article [contentfulSectionContent]="contentfulSectionContent" />
            <app-contentful-rich-text-block [contentfulSectionContent]="contentfulSectionContent" />
            <app-contentful-biography [contentfulSectionContent]="contentfulSectionContent" />
          </div>
        </div>
        <app-contentful-related-products [contentfulSectionContent]="contentfulSectionContent" />
        <app-contentful-related-articles [contentfulSectionContent]="contentfulSectionContent" />
      }
      @if (contentfulSectionContent.layout) {
        <div>
          @if (contentfulSectionContent.layout === 'faq') {
            <div class="d-contents faq-page">
              <app-contentful-faq [contentfulSectionContent]="contentfulSectionContent" />
            </div>
          }
          @if (contentfulSectionContent.layout === 'page') {
            <app-contentful-landing-page [contentfulSectionContent]="contentfulSectionContent" />
          }
        </div>
      }
    </section>
  }
}

@if (contentfulSectionsContent && FAQLandingContent) {
  <app-contentful-faq-landing [FAQLandingContent]="FAQLandingContent" />
}
